import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { config } from '@/config';
import { prepareHeaders } from '@/configuration/tokenHandling/prepareHeaders';
import { TyreReadingsResponse } from '@/generated/GeneratedApiTypes';

interface GetTyreReadingsParams {
    assetId: string;
    axlePosition?: string;
    axleSide?: string;
}

export const api = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({ baseUrl: config.backend.BACKEND_URI, prepareHeaders }),
    endpoints: (build) => ({
        getTyreReadings: build.query<TyreReadingsResponse, GetTyreReadingsParams>({
            query: ({ assetId, axlePosition, axleSide }) => {
                const params = new URLSearchParams();
                if (axlePosition) {
                    params.set('axle_position', axlePosition);
                }
                if (axleSide) {
                    params.set('axle_side', axleSide);
                }
                const queryString = params.toString();
                return `/tyres/${assetId}${queryString ? `?${queryString}` : ''}`;
            },
        }),
    }),
});

export const { useGetTyreReadingsQuery } = api;
